// App-wide sheets (iOS AppSheet / AppRouting.swift), each lazily loaded from the feature folder that owns it.

import { lazy, Suspense } from 'preact/compat';
import type { AppSheet } from './env';

const DownloadsSheet = lazy(() => import('./more/DownloadsSheet').then((m) => m.DownloadsSheet));
const WaypointEditorSheet = lazy(() => import('./trip/WaypointEditorSheet').then((m) => m.WaypointEditorSheet));
const POIDetailSheet = lazy(() => import('./map/POIDetailSheet').then((m) => m.POIDetailSheet));
const SpotCheckSheet = lazy(() => import('./map/SpotCheckSheet').then((m) => m.SpotCheckSheet));
const ResponsibleBivouacSheet = lazy(() => import('./more/ResponsibleBivouacSheet').then((m) => m.ResponsibleBivouacSheet));
const SourcesSheet = lazy(() => import('./more/SourcesSheet').then((m) => m.SourcesSheet));
const RegulationsSheet = lazy(() => import('./more/RegulationsSheet').then((m) => m.RegulationsSheet));

export function SheetHost({ sheet }: { sheet: AppSheet }) {
  const content = (() => {
    switch (sheet.kind) {
      case 'downloads':
        return <DownloadsSheet stageIDs={sheet.stageIDs} />;
      case 'waypointEditor':
        return <WaypointEditorSheet coordinate={sheet.coordinate} elevation={sheet.elevation} waypointID={sheet.waypointID} />;
      case 'poiDetail':
        return <POIDetailSheet poi={sheet.poi} />;
      case 'spotCheck':
        return <SpotCheckSheet coordinate={sheet.coordinate} />;
      case 'responsibleBivouac':
        return <ResponsibleBivouacSheet />;
      case 'sources':
        return <SourcesSheet />;
      case 'regulations':
        return <RegulationsSheet />;
    }
  })();
  return <Suspense fallback={null}>{content}</Suspense>;
}
